import { useParams } from "react-router";
import { invariant } from "src/common/utils/invariant.js";
import { useLoadedCompanyDomain } from "src/routes/routeDataHooks.js";
import { useGetPlanQuery } from "./api/planApi.js";
import { useLoadedLegalEntity } from "src/routes/routeDataHooks.js";

export const useCurrentPlan = () => {
	const companyDomain = useLoadedCompanyDomain();
	const legalEntity = useLoadedLegalEntity();
	const { planId } = useParams();

	invariant(planId);

	const {
		data: plan,
		isLoading,
		isError,
	} = useGetPlanQuery({
		planId,
		companyDomainId: companyDomain.id,
		legalEntityId: legalEntity.id,
	});

	return { planId, plan, isLoading, isError };
};

export const useCurrentPlanOrThrow = () => {
	const currentPlan = useCurrentPlan();
	invariant(currentPlan.plan);

	return currentPlan.plan;
};
